import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { uniqueId } from '@co-3/ctrl-ui/common';
import {
    CtrlOverflowMenuDirective,
    CtrlOverflowMenuItemDirective,
    CtrlOverflowMenuOpenerDirective,
} from '@co-3/ctrl-ui/display';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

interface KebabMenuBaseItem {
    label: string;
    icon: string;
}

interface KebabMenuActionItem<T> extends KebabMenuBaseItem {
    action: (context: T) => void;
}

interface KebabMenuRouterLinkItem extends KebabMenuBaseItem {
    route: string[];
}

type KebabMenuItem<T> = KebabMenuActionItem<T> | KebabMenuRouterLinkItem;

@Component({
    selector: 'app-kebab-menu',
    templateUrl: './kebab-menu.component.html',
    styleUrls: ['./kebab-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CtrlIconComponent,
        CtrlOverflowMenuDirective,
        CtrlOverflowMenuItemDirective,
        CtrlOverflowMenuOpenerDirective,
        RouterLink,
    ],
})
export class KebabMenuComponent<T> {
    @Input()
    public context: T;
    @Input()
    public menuItems: KebabMenuItem<T>[];

    protected menuId = uniqueId('kebab-menu-');

    protected isActionItem(item: KebabMenuItem<T>): item is KebabMenuActionItem<T> {
        return 'action' in item && typeof item.action === 'function';
    }

    protected isRouterLinkItem(item: KebabMenuItem<T>): item is KebabMenuRouterLinkItem {
        return 'route' in item && Array.isArray(item.route);
    }
}
